export const ImageLightBoxActions = {
    SHOW: 'SHOW',
    HIDE: 'HIDE',
    EXPAND: 'EXPAND',
};
